var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneTeacherSchoolIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "126px",
    viewBox: "0 0 160 126",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5DA6E7EE-0A33-4067-9800-95A43453A5A0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groups",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groups-/-My-groups-/-Create-a-group-(For-Creater)",
    transform: "translate(-932.000000, -536.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(200.000000, 347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dialog"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groups-list",
    transform: "translate(63.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "School",
    transform: "translate(624.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "School-icon",
    transform: "translate(45.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#49853F",
    x: 7.17189696,
    y: 27.3457611,
    width: 145.789977,
    height: 91.3847307
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 138.196159,
    y: 42.2047775,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 138.196159,
    y: 65.8117096,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 138.196159,
    y: 89.409274,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 123.871101,
    y: 42.2047775,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 123.871101,
    y: 65.8117096,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 123.871101,
    y: 89.409274,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 109.562529,
    y: 42.2047775,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 109.562529,
    y: 65.8117096,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 109.562529,
    y: 89.409274,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.90549,0.0119906323 L30.231653,0.0119906323 C29.6278486,0.0119906323 29.0563631,0.284775164 28.6766441,0.754235833 L7.17227166,27.3408899 L152.964871,27.3408899 L131.460499,0.754235833 C131.08078,0.284775164 130.509294,0.0119906323 129.90549,0.0119906323 Z",
    id: "Shape",
    fill: "#37633A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5926,19.0632319 L102.5926,118.72 L57.0506792,118.72 L57.0506792,19.0632319 L57.0506792,17.2860079 C57.0506792,16.5958699 57.4064893,15.9544937 57.9920118,15.5891804 L78.762972,2.62997431 C79.4108702,2.22574427 80.2324085,2.22574427 80.8803067,2.62997431 L101.651267,15.5891804 C102.236789,15.9544937 102.5926,16.5958699 102.5926,17.2860079 L102.5926,19.0632319 Z",
    id: "Shape",
    fill: "#FEF192"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 0,
    y: 118.714379,
    width: 159.875222,
    height: 6.3070726,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3081967,89.4733489 L87.3332084,89.4733489 C88.4377779,89.4733489 89.3332084,90.3687794 89.3332084,91.4733489 L89.3332084,118.725621 L70.3081967,118.725621 L70.3081967,91.4733489 C70.3081967,90.3687794 71.2036272,89.4733489 72.3081967,89.4733489 Z",
    id: "Rectangle-path",
    fill: "#37633A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 42.5525059,
    y: 42.2047775,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 42.5525059,
    y: 65.8117096,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 42.5525059,
    y: 89.409274,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 28.2323185,
    y: 42.2047775,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 28.2323185,
    y: 65.8117096,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 28.2323185,
    y: 89.409274,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 13.9140047,
    y: 42.2047775,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FEF192",
    x: 13.9140047,
    y: 65.8117096,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#37633A",
    x: 13.9140047,
    y: 89.409274,
    width: 8.69733021,
    height: 15.0793443,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#49853F",
    x: 63.0227635,
    y: 54.6686651,
    width: 13.0394379,
    height: 11.3543794,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#49853F",
    x: 82.8151756,
    y: 54.6686651,
    width: 13.0394379,
    height: 11.3543794,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#49853F",
    x: 63.3071663,
    y: 70.6079625,
    width: 13.0394379,
    height: 11.3543794,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#49853F",
    x: 83.0917096,
    y: 70.6079625,
    width: 13.0394379,
    height: 11.3543794,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(64.266667, 13.600000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1333333,28.2666667 C6.32749756,28.2666667 0,21.9390388 0,14.133042 C0,6.32762783 6.32749756,0 14.1333333,0 C21.9391691,0 28.2666667,6.32762783 28.2666667,14.133042 C28.2666667,21.9390388 21.9391691,28.2666667 14.1333333,28.2666667 Z",
    id: "Shape",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1333333,26.1333333 C7.50617,26.1333333 2.13333333,20.7610304 2.13333333,14.1329894 C2.13333333,7.50563625 7.50617,2.13333333 14.1333333,2.13333333 C20.7604967,2.13333333 26.1333333,7.50563625 26.1333333,14.1329894 C26.1333333,20.7610304 20.7604967,26.1333333 14.1333333,26.1333333 Z",
    id: "Shape",
    fill: "#FEF192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1333333,8.53333333 C13.5444556,8.53333333 13.0666667,8.01424447 13.0666667,7.37315524 L13.0666667,5.9601781 C13.0666667,5.31967537 13.5444556,4.8 14.1333333,4.8 C14.722211,4.8 15.2,5.31967537 15.2,5.9601781 L15.2,7.37315524 C15.2,8.01424447 14.722211,8.53333333 14.1333333,8.53333333 Z",
    id: "Shape",
    fill: "#49853F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1333333,23.7333333 C13.5444556,23.7333333 13.0666667,23.2136581 13.0666667,22.5731553 L13.0666667,21.1601781 C13.0666667,20.5190887 13.5444556,20 14.1333333,20 C14.722211,20 15.2,20.5190887 15.2,21.1601781 L15.2,22.5731553 C15.2,23.2136581 14.722211,23.7333333 14.1333333,23.7333333 Z",
    id: "Shape",
    fill: "#49853F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8398219,15.2 L21.4268447,15.2 C20.7863419,15.2 20.2666667,14.7226295 20.2666667,14.1330636 C20.2666667,13.544037 20.7863419,13.0666667 21.4268447,13.0666667 L22.8398219,13.0666667 C23.4809113,13.0666667 24,13.544037 24,14.1330636 C24,14.7226295 23.4809113,15.2 22.8398219,15.2 Z",
    id: "Shape",
    fill: "#49853F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7254039,15.4666667 L14.2085067,15.4666667 C13.5781278,15.4666667 13.0666667,14.9331323 13.0666667,14.2742024 L13.0666667,11.8591309 C13.0666667,11.2002009 13.5781278,10.6666667 14.2085067,10.6666667 C14.8388855,10.6666667 15.3503467,11.2008039 15.3503467,11.8591309 L15.3503467,13.0823411 L16.7248267,13.0823411 C17.3557827,13.0823411 17.8666667,13.6158754 17.8666667,14.2742024 C17.8666667,14.9331323 17.3557827,15.4666667 16.7254039,15.4666667 Z",
    id: "Shape",
    fill: "#FBB040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37315534,15.2 L5.96017814,15.2 C5.31908873,15.2 4.8,14.7226295 4.8,14.1330636 C4.8,13.544037 5.31908873,13.0666667 5.96017814,13.0666667 L7.37315534,13.0666667 C8.0136581,13.0666667 8.53333333,13.544037 8.53333333,14.1330636 C8.53333333,14.7226295 8.0136581,15.2 7.37315534,15.2 Z",
    id: "Shape",
    fill: "#49853F"
  }))))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneTeacherSchoolIcon);
export default __webpack_public_path__ + "static/media/one-teacher-school-icon.330bc9c851cfffdee3b414ed2511ed08.svg";
export { ForwardRef as ReactComponent };